/**
 * Marks a reload the app triggered itself (language change, expired-session recovery), so unload guards
 * don't treat it as the user leaving.
 */
let intentional = false;

export function markIntentionalReload() {
  intentional = true;
}

export function isIntentionalReload() {
  return intentional;
}
